import { all, call } from 'redux-saga/effects';

import { generateBadgesStoreState } from './__fixtures__/badgesStore';
import { generateBranchStoreState } from './__fixtures__/branchStore';
import { generateLanguage } from './__fixtures__/language';
import { generateProjectLanguage } from './__fixtures__/projectLanguage';
import { generateProjectLanguageServerResponse } from './__fixtures__/projectLanguageServerResponse';
import { generateProjectStoreState } from './__fixtures__/projectStore';
import { CreateForm, LanguagesSchema, ProjectNameSchema, initialFormValues } from './components/NewProject';
import ProjectFooter from './components/ProjectFooter';
import { sagas as initActivitySagas } from './pages/Activity';
import { generateContributor } from './pages/Contributors/__fixture__';
import { generateDownloadDataStoreState, generateDownloadDataStoreStateExportConfig } from './pages/Download';
import downloadData from './pages/Download/reducers/downloadData/reducers';
import downloadExport from './pages/Download/reducers/downloadExport/reducers';
import downloadGenerate from './pages/Download/reducers/downloadGenerate/reducers';
import initDownloadSagas from './pages/Download/sagas';
import translationEditor from './pages/Editor/reducers';
import initEditorSagas from './pages/Editor/sagas';
import { generateProjectsStoreStateBadges } from './pages/ProjectsList/__fixtures__/badges';
import { generateAllProjectLanguages } from './pages/ProjectsList/__fixtures__/languages';
import { generateProjectsStoreStateProject } from './pages/ProjectsList/__fixtures__/project';
import { generateProjectsStoreState } from './pages/ProjectsList/__fixtures__/projectsStore';
import { generateProjectsStoreStateTags } from './pages/ProjectsList/__fixtures__/tags';
import {
    type Contributor,
    TasksSidebarWidget,
    generateTaskForWidget,
    generateTaskLanguage,
    generateTasksStoreState,
    initTaskWidgetSagas,
    initTasksSagas,
    tasksReducer,
} from './pages/Tasks';
import badges from './store/badges/reducers';
import initBadgeSagas from './store/badges/sagas';
import project from './store/project/reducers';
import userRights from './store/userRights/reducers';
import { ProjectType } from './types/project';

export { projectsActions } from './pages/ProjectsList/reducers';

export type { Project } from './types/project';

export { default as ProjectLayout } from './components/ProjectLayout';

export { projectMiddleware } from './projectMiddleware';

export { type TaskStyleGuide } from './pages/Tasks';

export const reducers = {
    downloadData,
    downloadExport,
    downloadGenerate,
    project,
    badges,
    userRights,
    tasks: tasksReducer,
    translationEditor,
};

export function* saga() {
    yield all([
        call(initDownloadSagas),
        call(initTasksSagas),
        call(initBadgeSagas),
        call(initActivitySagas),
        call(initTaskWidgetSagas),
        call(initEditorSagas),
    ]);
}

export {
    type Contributor,
    CreateForm,
    initialFormValues,
    generateTaskForWidget,
    generateTaskLanguage,
    generateProjectStoreState,
    generateBadgesStoreState,
    generateBranchStoreState,
    generateTasksStoreState,
    generateProjectLanguage,
    generateLanguage,
    generateProjectLanguageServerResponse,
    generateProjectsStoreState,
    generateProjectsStoreStateProject,
    generateProjectsStoreStateTags,
    generateProjectsStoreStateBadges,
    generateAllProjectLanguages,
    generateDownloadDataStoreState,
    generateDownloadDataStoreStateExportConfig,
    ProjectFooter,
    LanguagesSchema,
    ProjectNameSchema,
    generateContributor,
    TasksSidebarWidget,
    ProjectType,
};
